<template>
  <div>
    <v-card class="mt-8 mx-8 pa-4">
      <v-card-actions class="text-left">
        <v-row>
          <v-col cols="12" class="text-left">
            <v-icon class="back-link-icon" x-large @click="$router.push('/items/index')">mdi-arrow-left
            </v-icon>
          </v-col>
        </v-row>
      </v-card-actions>
      <v-card-title>ویرایش درس</v-card-title>
      <v-card-text>
        <v-row>
          <v-col cols="3">
            <v-text-field color="black" v-model="item.title" label="عنوان"></v-text-field>
          </v-col>
          <v-col cols="3">
            <v-select label="دسته بندی" :items="categories" item-text="label" item-value="id"
                      color="black" v-model="item.category_id">
            </v-select>
          </v-col>
          <v-col cols="2">
            <v-select label="وضعیت نمایش"
                      :items="[{text:'قابل مشاهده',value:1},{text:'غیر قابل مشاهده',value:0}]"
                      color="black" v-model="item.visibility">
            </v-select>
          </v-col>
          <v-col cols="4">
            <v-autocomplete :items="covers" item-text="tag" item-value="id" v-model="item.cover_id"
                            label="کاور مورد نظر را انتخاب کنید"></v-autocomplete>
          </v-col>
          <v-col cols="12">
            <v-textarea color="black" v-model="item.description" label="توضیحات درس"></v-textarea>
          </v-col>
          <v-col cols="12">
            فایل های درسی
          </v-col>
          <v-col cols="12">
            <v-row v-for="(itemFile, index) in item.files" :key="'file' + index">
              <v-col cols="1">
                <v-icon @click="removeItemFile(itemFile.id)" color="red" class="mx-2">mdi-trash-can-outline</v-icon>
              </v-col>
              <v-col cols="2">
                <v-text-field color="black"
                              v-model="itemFile.title"
                              label="عنوان"></v-text-field>
              </v-col>
              <v-col cols="2">
                <v-select label="دسته بندی" :items="itemFileCategories" item-text="label" item-value="id"
                          color="black"
                          v-model="itemFile.category_id">
                </v-select>
              </v-col>
              <v-col cols="2">
                <v-select label="وضعیت نمایش"
                          :items="[{text:'قابل مشاهده',value:1},{text:'غیر قابل مشاهده',value:0}]"
                          color="black"
                          v-model="itemFile.visibility">
                </v-select>
              </v-col>
              <v-col cols="2">
                <v-autocomplete :items="itemFileCovers" item-text="tag" item-value="id"
                                v-model="itemFile.cover_id"
                                label="کاور مورد نظر را انتخاب کنید"></v-autocomplete>
              </v-col>
              <v-col cols="6">
                <v-textarea color="black"
                            v-model="itemFile.description"
                            label="توضیحات فایل درسی"></v-textarea>
              </v-col>
              <v-col cols="6">
                <v-textarea color="black" v-model="itemFile.comment"
                            label="دست نوشته فایل درسی"
                            hint="این نوشته سمت کاربر نمایش داده نمی شود و فقط برای یادداشت شما می باشد که در جستجو از آن استفاده کنید."></v-textarea>
              </v-col>
            </v-row>
          </v-col>

          <v-col cols="12" v-if="itemFileDefaults.length">
            <v-row>

              <v-col cols="12">
                دیکته
              </v-col>
              <v-col cols="12">
                <v-btn color="primary" class="mx-2" @click="addDictation()">
                  <v-icon>mdi-plus</v-icon>
                </v-btn>
                <v-btn color="warning" class="mx-2" @click="removeDictation()">
                  <v-icon>mdi-minus</v-icon>
                </v-btn>
              </v-col>
              <v-col cols="12" v-for="(count,index) in dictationCount" :key="index+'item-dictation'">
                <v-select :items="dictations" item-text="title" item-value="id" v-model="selectedDictationIds[index]">
                </v-select>
              </v-col>

              <v-col cols="12">
                تعداد درس اضافه
              </v-col>
              <v-col cols="12">
                <v-btn color="success" class="mx-2" @click="changeLessonFileCount(true)">
                  <v-icon>mdi-plus</v-icon>
                </v-btn>
                <v-btn color="error" class="mx-2" @click="changeLessonFileCount(false)">
                  <v-icon>mdi-minus</v-icon>
                </v-btn>
              </v-col>
              <v-col cols="12" v-for="counter in lessonFileCount" :key="'counter'+counter">
                <v-row>
                  <v-col cols="12">
                    <v-autocomplete v-model="selectedFileDefaultIds[counter-1]"
                                    label="فایل درسی مورد نظر را انتخاب کنید."
                                    :items="itemFileDefaults"
                                    item-text="title" item-value="id">
                    </v-autocomplete>
                  </v-col>
                  <v-col cols="12">
                    <v-row v-if="itemFileDefaults[selectedFileDefaultIds[counter-1]]">
                      <v-col cols="3">
                        <v-text-field color="black"
                                      v-model="itemFileDefaults[selectedFileDefaultIds[counter-1]].title"
                                      label="عنوان"></v-text-field>
                      </v-col>
                      <v-col cols="3">
                        <v-select label="دسته بندی" :items="itemFileCategories" item-text="label" item-value="id"
                                  color="black"
                                  v-model="itemFileDefaults[selectedFileDefaultIds[counter-1]].category_id">
                        </v-select>
                      </v-col>
                      <v-col cols="1">
                        <v-select label="وضعیت نمایش"
                                  :items="[{text:'قابل مشاهده',value:1},{text:'غیر قابل مشاهده',value:0}]"
                                  color="black"
                                  v-model="itemFileDefaults[selectedFileDefaultIds[counter-1]].visibility">
                        </v-select>
                      </v-col>
                      <v-col cols="3">
                        <v-autocomplete :items="itemFileCovers" item-text="tag" item-value="id"
                                        v-model="itemFileDefaults[selectedFileDefaultIds[counter-1]].cover_id"
                                        label="کاور مورد نظر را انتخاب کنید"></v-autocomplete>
                      </v-col>
                      <v-col>
                        <v-text-field label="اولویت" type="number" color="black"
                                      v-model="itemFileDefaults[selectedFileDefaultIds[counter-1]].order">
                        </v-text-field>
                      </v-col>
                      <v-col cols="6">
                        <v-textarea color="black"
                                    v-model="itemFileDefaults[selectedFileDefaultIds[counter-1]].description"
                                    label="توضیحات فایل درسی"></v-textarea>
                      </v-col>
                      <v-col cols="6">
                        <v-textarea color="black" v-model="itemFileDefaults[selectedFileDefaultIds[counter-1]].comment"
                                    label="دست نوشته فایل درسی"
                                    hint="این نوشته سمت کاربر نمایش داده نمی شود و فقط برای یادداشت شما می باشد که در جستجو از آن استفاده کنید."></v-textarea>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
                <v-divider></v-divider>
              </v-col>
              <v-col cols="12">
                <v-divider></v-divider>
                <v-divider></v-divider>
                <v-divider></v-divider>
                <v-divider></v-divider>
              </v-col>
            </v-row>
          </v-col>


          <v-col cols="12" class="text-center">
            <v-btn block color="success" class="normal-font-btn" @click="update()">ویرایش</v-btn>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <v-dialog v-model="deleteDialog" max-width="50vw">
      <v-card class="ma-0">
        <v-row class="ma-0">
          <v-col cols="12">
            آیا از حذف این آیتم اطمینان دارید؟
          </v-col>
          <v-col cols="6">
            <v-btn color="warning" @click="finalDestroy">
              بله
            </v-btn>
          </v-col>
          <v-col cols="6">
            <v-btn color="success" @click="deleteDialog=false">
              خیر
            </v-btn>
          </v-col>
        </v-row>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>

export default {
  name: "ItemEdit",
  data() {
    return {
      dictations:[],
      dictationCount: 0,
      selectedDictationIds: [],
      selectedEntityId: null,
      deleteDialog: false,
      covers: [],
      categories: [],
      item: {
        category_id: null,
        visibility: null,
        title: null,
        description: null,
        cover: null,
      },


      itemFileDefaults: [],
      lessonFileCount: 0,
      selectedFileDefaultCounter: [],
      selectedFileDefaultIds: [],
      itemFileCovers: [],
      itemFileCategories: [],


    }
  },
  mounted() {
    this.getItem()
    this.getCategories()
    this.getCovers()
    this.getItemFileDefaults()
    this.getItemFileCategories()
    this.getItemFileCovers()
    this.getDictation()
  },
  methods: {
    addDictation() {
      this.dictationCount = this.dictationCount + 1
    },
    removeDictation() {
      this.dictationCount--
      this.selectedDictationIds.pop();
    },
    getDictation() {
      window.axios.get('course/dictation/index?per_page=1000').then((res) => {
        this.dictations = res.data.data.data
      })
    },
    finalDestroy() {
      window.axios.get('course/item/detach/' + this.item.id + '/' + this.selectedEntityId).then(() => {
        this.getItem()
      }).catch((err) => {
        this.openSnackbar(err.response.data.message, '#F1416C')
      }).finally(() => {
        this.deleteDialog = false
      })
    },
    removeItemFile(itemFileId) {
      this.selectedEntityId = itemFileId
      this.deleteDialog = true
    },
    getItemFileCovers() {
      window.axios.get('file-manager/cover/index?type=lesson_file_cover&per_page=10000').then((res) => {
        this.itemFileCovers = res.data.data.data
      })
    },
    getItemFileDefaults() {
      window.axios.get('file-manager/item-file/index').then((res) => {
        res.data.data.forEach((file) => {
          this.$set(this.itemFileDefaults, file.id, file)
        })
      })
    },
    getItemFileCategories() {
      window.axios.get('category/index?per_page=1000&type=item_file').then((res) => {
        this.itemFileCategories = res.data.data.data
      })
    },
    changeLessonFileCount(operator) {
      if (operator) {
        this.lessonFileCount++
      } else {
        if (this.lessonFileCount >= 1) {
          this.lessonFileCount--
          this.selectedFileDefaultIds.pop()
        }
      }
    },
    getCovers() {
      window.axios.get('file-manager/cover/index?type=lesson_cover&per_page=10000').then((res) => {
        this.covers = res.data.data.data
      })
    },
    getItem() {
      window.axios.get('course/item/get/' + this.$route.params.id).then((res) => {
        this.item = res.data.data
        this.dictationCount = this.item.dictations.length
        this.item.dictations.forEach((item) => {
          this.selectedDictationIds.push(item.id)
        })
      })
    },
    update() {
      this.itemFileDefaults.forEach((file) => {
        if (this.selectedFileDefaultIds.includes(file.id)) {
          file.is_new = true
          this.item.files.push(file)
        }
      })
      window.axios.post('course/item/update/' + this.$route.params.id, {
        dictation_ids: this.selectedDictationIds,
        item: this.item,
        item_files: this.item.files
      }).then(() => {
        this.openSnackbar("درس مورد نظر با موفقیت ویرایش شد.", 'success')
      }).catch((err) => {
        if (err.response.status === 422) {
          this.showValidationErrors(err, '#F1416C')
        } else if (err.response.status === 400) {
          this.openSnackbar(err.response.data.message, '#F1416C')
        }
      })
    },
    getCategories() {
      window.axios.get('category/index?per_page=1000&type=course_item').then((res) => {
        this.categories = res.data.data.data
      })
    },
  }
}
</script>

<style scoped>

</style>
